import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@monksflow/monks-ui';

type Row = Record<string, unknown>;

const text = (value: unknown) =>
  value === null || value === undefined || (typeof value === 'number' && !Number.isFinite(value))
    ? ''
    : typeof value === 'object'
      ? JSON.stringify(value)
      : String(value as string | number | boolean);

/** A widget's data as plain tables, for when the widget itself cannot be shown. */
export function DatasetTables({
  data,
  caption,
}: {
  data: Record<string, unknown>;
  caption: string;
}) {
  const lists = Object.entries(data).filter(
    (entry): entry is [string, Row[]] =>
      Array.isArray(entry[1]) && entry[1].every((row) => row !== null && typeof row === 'object'),
  );
  return (
    <div className="flex flex-col gap-md">
      <p className="m-0 text-sm text-muted-foreground">{caption}</p>
      {lists.map(([name, rows]) => {
        const columns = [...new Set(rows.flatMap((row) => Object.keys(row)))];
        return (
          <Table key={name}>
            <TableHeader>
              <TableRow>
                {columns.map((column) => (
                  <TableHead key={column}>{column}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell key={column}>{text(row[column])}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        );
      })}
    </div>
  );
}
